import { StyleSheet } from 'react-native';
import {
  ANNOUNCEMENT_MODAL_COLORS as C,
  ANNOUNCEMENT_MODAL_LAYOUT as L,
} from './announcementModal.constants';

export const getAnnouncementModalStyles = () =>
  StyleSheet.create({
    cardWrap: {
      width: '100%',
      maxWidth: L.MAX_CARD_WIDTH,
      alignSelf: 'center',
    },
    card: {
      borderRadius: 20,
      borderWidth: 1,
      borderColor: C.CARD_BORDER,
      backgroundColor: C.CARD_BG,
      paddingTop: 40,
      paddingBottom: 20,
      paddingHorizontal: 20,
      overflow: 'hidden',
      shadowColor: '#000',
      shadowOpacity: 0.4,
      shadowRadius: 24,
      shadowOffset: { width: 0, height: 8 },
      elevation: 12,
    },
    scroll: {
      maxHeight: L.MAX_CONTENT_HEIGHT,
    },
    closeButton: {
      position: 'absolute',
      top: 12,
      right: 12,
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: C.CLOSE_BG,
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2,
    },
    closeButtonPressed: {
      opacity: 0.7,
    },

    // Blocks
    heading: {
      fontSize: 22,
      lineHeight: 27,
      fontWeight: '800',
      letterSpacing: -0.3,
      color: C.HEADING,
      marginBottom: 4,
    },
    paragraph: {
      fontSize: 15,
      lineHeight: 22,
      fontWeight: '500',
      color: C.BODY,
      marginBottom: 4,
    },
    alignLeft: { textAlign: 'left' },
    alignCenter: { textAlign: 'center' },

    image: {
      width: '100%',
      borderRadius: 12,
      marginVertical: 8,
      backgroundColor: 'rgba(255,255,255,0.04)',
    },

    button: {
      width: '100%',
      minHeight: 50,
      borderRadius: 12,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 16,
      marginTop: 10,
    },
    buttonPrimary: {
      backgroundColor: C.BUTTON_PRIMARY_BG,
    },
    buttonSecondary: {
      backgroundColor: C.BUTTON_SECONDARY_BG,
    },
    buttonPressed: {
      opacity: 0.85,
    },
    buttonLabelPrimary: {
      fontSize: 16,
      fontWeight: '800',
      color: C.BUTTON_PRIMARY_TEXT,
    },
    buttonLabelSecondary: {
      fontSize: 16,
      fontWeight: '700',
      color: C.BUTTON_SECONDARY_TEXT,
    },
  });
